import { render, staticRenderFns } from "./WorkspaceFabricCreatePlane.vue?vue&type=template&id=4ca45012&scoped=true&"
import script from "./WorkspaceFabricCreatePlane.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabricCreatePlane.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabricCreatePlane.vue?vue&type=style&index=0&id=4ca45012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca45012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca45012')) {
      api.createRecord('4ca45012', component.options)
    } else {
      api.reload('4ca45012', component.options)
    }
    module.hot.accept("./WorkspaceFabricCreatePlane.vue?vue&type=template&id=4ca45012&scoped=true&", function () {
      api.rerender('4ca45012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabricCreatePlane.vue"
export default component.exports